import * as okrPopUpConstants from '../constants/okrPopUp.constants';
import { OkrPopUp, ActionOkrPopUp } from '../types/okrpopup.types';

const initialState = {
    show: false
};

const okrPopUpReducer = (state: OkrPopUp = initialState, action: ActionOkrPopUp) => {
    const initState = state;
    let OkrActiveTab: any;
    let OkrPopTabs: Record<string, unknown>;
    let goalPopUpMetric: [];
    switch (action.type) {
        case okrPopUpConstants.GET_OKR_TAB: {
            OkrActiveTab = action.payload.filter((t: any) => t.active == true);

            // the URL $_GET param 'cm' maps to 'isOpenCommentPopup' which makes the comment tab be
            // active whenever passed that parameter sets the selectTabs variable to 'comments'
            if (state?.selectTabs === 'comments') {
                OkrActiveTab = action.payload.filter((t: any) => t.id === 'comments');
            }

            OkrPopTabs = ({ ...OkrPopTabs, ...action.payload })
            return {
                ...state,
                OkrActiveTab: OkrActiveTab[0].text,
                OkrPopTabs

            };
        }
        case okrPopUpConstants.SET_OKR_TAB: {
            const activeTab = initState.OkrActiveTab;
            const OkrTabs = initState.OkrPopTabs || {};
            let okrActiveTab = activeTab;
            Object.values(OkrTabs).map((t: any) => {
                if (t.text == action.payload) {
                    t.active = true;
                    okrActiveTab = t.text;
                } else {
                    t.active = false;
                }
                return okrActiveTab;
            });
            console.log('activeMenu----------', okrActiveTab);
            return {
                ...state,
                OkrActiveTab: okrActiveTab
            };
        }
        case okrPopUpConstants.DISABLE_MODAL: {
            const showModal = action.payload;
            return {
                ...state,
                show: showModal
            };
        }
        case okrPopUpConstants.GET_GOAL_METRIC: {
            goalPopUpMetric = action.payload.goals.goal_metrics || [];
            return {
                ...state,
                goalkrWeight: action.payload.krWeight,
                goalkrMultiperAlter: action.payload.krMultiperAlter,
                goalPopUpMetric

            };
        }
        case okrPopUpConstants.SELECTED_METRIC: {
            return {
                ...state,
                selectedMetric: action.payload.metricId,
                selectedMetricId: action.payload.metricId,
            };
        }
        case okrPopUpConstants.METRIC_GRAPH_DATA: {
            const { metricId } = action.payload;
            const { chartData } = action.payload;
            state.goalPopUpMetric = state.goalPopUpMetric.map((t: any) => {
                if (t.id == metricId) {
                    if (typeof t.chart_data == 'undefined') {
                        t.chart_data = chartData.chart_data;
                    }
                    if (typeof t.chart_data_sub == 'undefined') {
                        t.chart_data_sub = chartData.chart_data_sub;
                        t.surveyUsers = chartData.surveyUsers;
                    }
                }
                return t;
            });
            return {
                ...state,
            };
        }
        case okrPopUpConstants.AFTER_METRIC_CONFIDENCE: {
            const metrId = action.payload.metricId;
            state.goalPopUpMetric = state.goalPopUpMetric.map((t: any) => {
                if (t.id == metrId) {
                    t.confidence = action.payload
                }
                return t;
            });
            return {
                ...state,
            }
        }
        default: {
            return state;
        }
    }
}
export default okrPopUpReducer;
